/**
 * @module Core
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */
/** */

export const CONTENT_ENDPOINT = {
  HEADER_PRIMARY_NAVIGATION: 'header-primary-navigation',
  DEVICE_ASSESSMENT_SUMMARY: 'device-assessment/summary',
  REP_DASH_BOARD: 'repDashboard',
  COVERAGE_MAP: 'coverage-map',
  QUICK_LINKS: 'quickLinks',
  USAGE: 'rep/usage',
  GLOBAL_MESSAGES: 'globalMessages',
  FOOTER: 'footer',
  UNSAVED_CHANGES: 'unsavedChanges',
  COMPARE_DEVICES: 'compareDevices',
  WRITE_MEMO: 'writeMemo',
  PLAN_DETAILS: 'plan-details',
  PRODUCT_DETAILS: 'productDetails/deviceDetails',
  PRODUCT_REVIEWS: 'read-reviews',
  HOME: 'home',
  WEB_HOME: 'prepaid-home',
  MRC: 'mrc.content',
  ORDER_PAYMENT: 'cart/payment',
  REP_ROLE: 'repRole',
  ON_DEMAND_REPORTS: 'onDemandReports',
  STORED_PAYMENT_METHODS: 'my-profile/stored-payment-methods',
  STORE_OPS: 'store-ops',
  BYOD_FAQ: 'bring-your-own-device/faq',
  BYOD_LANDING: 'bring-your-own-device',
  SUPPORT_LANDING: 'support-landing',
  ACCOUNT_BILLING_INFO: 'cart/account-and-billing-info',
  LINE_SETUP: 'cart/line-setup',
  CART: 'cart',
  TRANSFER_PAYMENT: 'billing-landing/transfer-payment',
  TRANSACTION_HISTORY: '/billing-landing/transaction-history',
  BROWSE_ENTRY_MODAL: '/content/global/modal/browseModel.content.json',
  ONE_TIME_PIN_MODAL: '/content/t-mobile/en/shared/one-time-pin.content.json',
  OPEN_CASH_DRAWER: '/cart/opencashdrawer',
  NEW_NUMBER_CHANGE_MSISDN_ORDER: 'change-msisdn/newNumber-order',
  PORTIN_CHANGE_MSISDN_ORDER: 'change-msisdn/portIn-order',
  PENDING_CREDITS: 'billing-landing/transaction-history',
  PENDING_CREDITS_CONTENT: 'billing-landing/pending-credits',
  CART_REVIEW: 'cart/review',
  RAP_HOME_PAGE: 'rap-home',
  RETAIL_ACTION: 'retail-activation',
  EBB: 'ebb',
  RECEIPT_RETRIEVAL: 'receipt-retrieval',
  ONE_TIME_PIN: 'one-time-pin',
};
